/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2, breakpoints, typography2Color } from '@coursera/cds-core';

import DottedSeparator from 'bundles/unified-description-page-common/components/shared/DottedSeparator';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

export type SkillPathwayCourseItemSubtitleV2Element = React.ReactElement<
  Props,
  typeof SkillPathwayCourseItemSubtitleV2
>;

interface Props {
  moduleCount?: number;
  skillCount?: number;
}

const styles = {
  container: css`
    display: flex;
    white-space: nowrap;

    ${breakpoints.down('sm')} {
      flex-wrap: wrap;
      white-space: unset;
    }
  `,
  viewCourseLink: css`
    ${typography2Color.body};

    &:hover {
      ${typography2Color.body};
    }
  `,
  viewReviewsLink: css`
    ${typography2Color.supportText};

    &:hover {
      ${typography2Color.supportText};
    }
  `,
};

const SkillPathwayCourseItemSubtitleV2 = ({ moduleCount, skillCount }: Props) => {
  return (
    <Typography2 variant="bodySecondary" color="supportText" component="div" css={styles.container}>
      {moduleCount && (
        <React.Fragment>
          <FormattedMessage message={_t('{moduleCount} modules')} moduleCount={moduleCount} />
          <DottedSeparator />
        </React.Fragment>
      )}
      <div>{_t('Around 2 hours per module')}</div>
      {skillCount && (
        <React.Fragment>
          <DottedSeparator />
          <FormattedMessage message={_t('{skillCount} skills')} skillCount={skillCount} />
        </React.Fragment>
      )}
    </Typography2>
  );
};

export default SkillPathwayCourseItemSubtitleV2;
